import type { ProvenanceType } from '@vivport/backend/types';
import { useCallback } from 'react';
import { useSpeak2MeStore } from '@/store/speak2meStore';

export interface SetActiveProvenanceTarget {
  id: number;
  type: ProvenanceType;
  code: string;
}

export function useSetActiveProvenance(): (target: SetActiveProvenanceTarget) => void {
  const setIsOpen = useSpeak2MeStore((s) => s.setIsOpen);
  const setResumeProvenance = useSpeak2MeStore((s) => s.setResumeProvenance);
  return useCallback(
    (target: SetActiveProvenanceTarget) => {
      setResumeProvenance(target);
      setIsOpen(true);
    },
    [setIsOpen, setResumeProvenance]
  );
}
